import { RoutingRuleModel } from '@em/models/restapi/RoutingRule.Model';
import { ChangeTrackedCollectionModel } from '@shared/models/restapi/ChangeTrackedCollection.Model';

export class RoutingRuleCollectionModel extends ChangeTrackedCollectionModel<RoutingRuleModel> {
    public constructor() {
        super(RoutingRuleModel);
    }
}
